<template>
  <section id="admin-agent-list" :dir="$functions.currentLangDirection()">
    <b-card class="admin-page-mobile">
      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-primary'"
        @click="showModal"
      >
        <feather-icon
          icon="PlusIcon"
          size="22"
          class="align-text-top"
        />
        {{ $t('Add') }}
      </b-button>

      <v-data-table
        v-bind="{dark : isMobile }"
        :headers="headers"
        :items="desserts"
        :search="search"
        mobile-breakpoint="0"
        loading
        :loading-text="$t('Loading')"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('Search')"
            class="mx-4"
            style=""
          />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            @click="onEditItem(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            style="margin-right: 7px"
            @click="onDeleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </b-card>
    <!-- modal login-->
    <b-modal
      ref="modal-addAgent"
      cancel-variant="outline-secondary"
      :ok-title="$t('Add')"
      :cancel-title="$t('Close')"
      centered
      :title="$t('New')"
    >
        <b-form>
          <b-form-group
            label="لیست کاربران:"
            label-for="vi-port"
          >
            <b-input-group class="input-group-merge">
            <model-list-select
                v-model="selected"
                :list="options"
                option-value="_id"
                :custom-text="optionDisplayText"
                placeholder="کاربران"
            />
            </b-input-group>
          </b-form-group>
        </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal"
        >
          {{ $t('Close') }}
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalOk()"
        >
          {{ $t('Save') }}
        </b-button>
      </template>
    </b-modal>
  </section>

</template>
<script>
import {
  BCard, BCardBody, BButton, BModal, BForm, BFormGroup, BFormSelect, BInputGroup, BInputGroupPrepend, BCardHeader,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Vue from 'vue'
import router from '@/router'
import customerService from '@/services/customer.service'
import Customer from '@/models/customer'
import { ModelListSelect } from 'vue-search-select'

import 'vue-search-select/dist/VueSearchSelect.css'
export default {
  components: {
    ModelListSelect,
    BCardHeader,
    BCard,
    BModal,
    BButton,
    BCardBody,
    BForm,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      search: '',
      customer: new Customer('', '', '', '', '', ''),
      desserts: [],
      selected: '',
      options: [],
      required,
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Family', value: 'family' },
        { text: 'Mobile number', value: 'mobile' },
        { text: 'Type', value: 'type' },
        { text: 'Creation date', value: 'creationDate' },
        { text: 'Operations', value: 'actions', sortable: false },
      ]
    },
  },
  async mounted() {
    this.initializeOption()
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    optionDisplayText(animation) {
      return `${animation.name} ${animation.family} - ${animation.mobile}`
    },
    initializeOption() {
      try {
        customerService.getAll({ type: 0 }).then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                this.options = res.result.data
              } else {
                this.options = []
              }
            }
          },
        )
      } catch (err) {
        // console.log(err)
      }
    },
    initialize() {
      this.desserts = []
      customerService.getAll({ type: 1 }).then(
        res => {
          if (res.status === 'success') {
            // console.log(res.status)
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/admin/agent/add' })
    },
    modalOk() {
      this.locale = 'fa'
      this.$refs.Validation.validate().then(success => {
        if (success) {
          customerService.addAgent({ _id: this.selected })
            .then(
              res => {
                if (res.status === 'success') {
                  this.$refs['modal-addAgent'].hide()
                  this.initialize()
                }
              },
              error => {
                this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('Error'),
                    text: this.message,
                    icon: 'XIcon',
                    variant: 'danger',
                    dir: Vue.prototype.$functions.currentLangDirection(),
                  },
                })
              },
            )
        }
      })
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        customerService.removeAgent({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                  dir: Vue.prototype.$functions.currentLangDirection(),
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Error'),
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          },
        )
      } else {
        index = ''
      }
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      const id = this.desserts[index]._id
      router.push({ name: 'admin-agent-edit', params: { id } })
    },
    showModal() {
      this.initializeOption()
      this.$refs['modal-addAgent'].show()
    },
    hideModal() {
      this.$refs['modal-addAgent'].hide()
    },
  },
}
</script>
